import { SearchOutlined } from '@ant-design/icons'
import { Button, Col, Input, notification, Row, Skeleton, Typography } from 'antd'
import axios from 'axios'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import CustomBreadcrumb from 'src/components/CustomBreadcrumb'
import VerifyCodeViewTrackingModal from 'src/components/Profile/VerifyCodeViewTrackingModal'
import { SEO } from 'src/components/SEO'
import DetailTracking from 'src/components/TrackingDetail/Detail'
import ListTracking from 'src/components/TrackingDetail/List'
import APIConstants from 'src/configs/API'
import BASE_CONFIG from 'src/configs/base'
import dashboardService from 'src/services/dashboard.service'
import {
	useTrackingHistory,
	useTrackingOrderDetail,
	useTrackingOrderPackage
} from 'src/services/tracking.service'
import { handleURI } from 'src/utils/common'
import RecaptchaModal from './recaptcha'

const { Text } = Typography

const STATUS_SHOW_UPDATE_BUTTON = [20, 21, 23, 24, 16]

const openNotificationWithIcon = (type, title) => {
	notification[type]({
		message: 'Hệ thống',
		description: title,
	})
}

const Tracking = () => {
	const router = useRouter()
	const [openCaptcha, setOpenCaptcha] = useState(false)
	const [captchaPassed, setCaptchaPassed] = useState(false)

	const [inputSearch, setInputSearch] = useState('')
	const [orderDetail, setOrderDetail] = useState({})
	const [orderPackage, setOrderPackage] = useState([])
	const [statusCode, setStatusCode] = useState(null)
	const [orderHistory, setOrderHistory] = useState([])
	const [isDetail, setIsDetail] = useState(false)
	const [isLoading, setIsLoading] = useState(true)

	const [user, setUser] = useState({})
	const [isFullInfo, setIsFullInfo] = useState(false)
	const [phoneNumber, setPhoneNumber] = useState('')
	const [keyword, setKeyword] = useState('')
	const [isSplitOrder, setIsSplitOrder] = useState(false)

	// const { orders, isLoading: isLoadingTracking } = useTrackingOrder(keyword)
	const [orders, setOrders] = useState({})
	const [isLoadingTracking, setIsLoadingTracking] = useState(false)

	const { order } = useTrackingOrderDetail(keyword, user, phoneNumber, user?.clientID ? true: captchaPassed)
	const { packages } = useTrackingOrderPackage(keyword)
	const { history } = useTrackingHistory(keyword, user, isFullInfo)
	const [styleCreateOrder, setStyleCreateOrder] = useState(
		typeof window !== 'undefined'
			? localStorage.getItem('StyleCreateOrder') != 'undefined' &&
				localStorage.getItem('StyleCreateOrder')
				? JSON.parse(localStorage.getItem('StyleCreateOrder'))
				: ''
			: ''
	)
	const isShowUpdateButton = order?.canEdit
	const isShowSendButton = Number(statusCode) === 20
	const [openVerifyModal, setOpenVerifyModal] = useState(false)

	const getTracking = (id) => {

		let idList = Array.from(new Set(id.split(',').map((item) => encodeURIComponent(item.trim()))))

		axios.get(`${APIConstants.API_TRACKINGMULTI}` + idList, {
			headers: {
				'ApiKey': 'PMS',
				'ClientID': user?.clientID || '',
			}
		}).then((res) => {
			if (res) {
				setIsLoadingTracking(res.data.isValidating)
				setOrders(res.data.orders)
			}
		})
	}

	useEffect(() => {
		if (keyword) {
			getTracking(keyword)
		}
		setCaptchaPassed(false)
	}, [keyword])
	useEffect(() => {
		if (orders) {
			setIsDetail(
				isSplitOrder ||
				(keyword
					.trim()
					.replace(' ', ',')
					.split(',')
					.filter((item) => !!item).length === 1 &&
					orders.length === 1)
			)
		}
	}, [orders])

	useEffect(() => {
		setIsLoading(isLoadingTracking)
	}, [isLoadingTracking])

	useEffect(() => {

		if (order) {
			if (order?.isError) {
				openNotificationWithIcon('warning', order?.errorMessage)
			} else {
				//TODO: check isRequiredPhoneNumber
				if (order?.isRequiredTrackingPhoneNumber && order?.isRequiredTrackingPhoneNumber === true) {
					setOpenVerifyModal(true)
					openNotificationWithIcon('warning', order?.messages || 'Vui lòng nhập số điện thoại để xem chi tiết đơn hàng')
				} else {
					setOrderDetail(order)
					setStatusCode(order?.order?.status)
					setIsFullInfo(order?.isFullInfoOrder)
				}
			}
		}
	}, [order])

	const onHandleSendNumberPhone = (code) => {
		setOpenVerifyModal(false)
		setPhoneNumber(code);
	}

	useEffect(() => {
		if (packages) {
			setOrderPackage(packages)
		}
	}, [packages])

	useEffect(() => {
		if (history) {
			setOrderHistory(history)
		}
	}, [history])

	useEffect(() => {
		if (router?.query?.ids) {
			let str = router?.query?.ids?.trim()
			let formatIds = str.replace(/ /g, '')
			setInputSearch(formatIds)
			setKeyword(formatIds)
		}
	}, [router])

	const handleTracking = (e) => {
		setIsSplitOrder(false)
		router.push('/tra-cuu-van-don/' + handleURI(inputSearch))
	}


	// const handleCaptchaSuccess = (token) => {
	//   setIsSplitOrder(false)
	//   setOpenCaptcha(false)
	//   router.push('/tra-cuu-van-don/' + handleURI(inputSearch))
	// }

	const handleCaptchaSuccess = () => {
		setCaptchaPassed(true)
		setOpenCaptcha(false)
		router.push('/tra-cuu-van-don/' + handleURI(inputSearch))
	}

	const handleKeyDown = (e) => {
		e.preventDefault()
		if (e.key === 'Enter') {
			handleTracking()
		}
	}

	useEffect(() => {
		setUser(JSON.parse(localStorage.getItem('user')))
	}, [])

	useEffect(() => {
		if (!router.isReady) return

		const ids = router?.query?.ids

		if (ids) {
			if (!user?.clientID) {
				setOpenCaptcha(true)
			} else {
				setCaptchaPassed(true)
			}

		}
	}, [router.isReady, router.query?.ids, user])

	return (
		<div className="tracking-wrapper">
			<SEO
				data={{
					title: `Theo dõi đơn hàng | ${BASE_CONFIG.SLOGAN}`,
					description: 'Tối ưu trải nghiệm với công nghệ theo dõi đơn hàng giao nhận mọi lúc, mọi nơi ngay tại website hoặc trên ứng dụng chuyển phát thông minh 247Express.',
					keywords: '247Express, 247, express, nhanh hơn bạn nghĩ',
					url: BASE_CONFIG.PAGE_URL + useRouter().asPath,
				}}
			/>
			<div className="tracking-header">
				<CustomBreadcrumb
					customRoute={[
						{
							breadcrumbName: 'Theo dõi đơn hàng',
							breadcrumbSubName: 'Theo dõi đơn hàng',
							path: '/khach-hang/dashboard',
						},
					]}
				/>
				<div className="feature">
					<Row gutter={[20, 10]} justify="end" style={{ width: '100%' }}>
						<Col xl={7} md={7} sm={24} xs={24}>
							<Input
								value={inputSearch}
								placeholder="Tra cứu vận đơn"
								allowClear
								prefix={<SearchOutlined onClick={handleTracking} style={{ cursor: 'pointer' }} />}
								onChange={(e) => setInputSearch(e.target.value)}
								onPressEnter={handleKeyDown}
								onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
							/>
						</Col>
						{isShowUpdateButton && (
							<Col xl={5} md={5} sm={24} xs={24}>
								<Button
									className="button-update"
									onClick={() =>
										router.push('/khach-hang/don-hang/thay-doi-thong-tin/' + handleURI(inputSearch))
									}
								>
									Thay đổi thông tin
								</Button>
							</Col>
						)}
						{isFullInfo && isShowSendButton && (
							<Col xl={4} md={4} sm={24} xs={24}>
								<Button
									className="button-update"
									onClick={() =>
										dashboardService.updateDraftToUse({ OrderCodes: inputSearch }).then((res) => {
											if (res?.errors?.length) {
												openNotificationWithIcon('error', res?.errorMessage)
											} else {
												openNotificationWithIcon('success', 'Gửi đơn thành công')
												router.push('/khach-hang/don-hang')
											}
										})
									}
								>
									Gửi đơn
								</Button>
							</Col>
						)}
						{isDetail && (
							<Col xl={4} md={4} sm={24} xs={24}>
								<Button
									className="button-update"
									onClick={() => {
										let currentStyle = styleCreateOrder?.find(
											(o) => o.user == user.customerID
										)?.style
										if (currentStyle) {
											if (currentStyle == 'old') {
												router.push('/khach-hang/tao-don-hang-sao-chep/' + inputSearch)
											} else {
												router.push({
													pathname: '/khach-hang/tao-don-hang/sao-chep',
													query: {
														orderCodeCopy: inputSearch,
													},
												})
											}
										} else {
											router.push({
												pathname: '/khach-hang/tao-don-hang/sao-chep',
												query: {
													orderCodeCopy: inputSearch,
												},
											})
										}
									}}
								>
									Sao chép
								</Button>
							</Col>
						)}

						<Col xl={4} md={4} sm={24} xs={24}>
							<Button className="button-contact">
								{/* <a aria-label={"247Express-Nhanh hơn bạn nghĩ"} href={`tel:19006980`}>Tra cứu</a> */}
								<a aria-label={'247Express-Nhanh hơn bạn nghĩ'} href={`#`} onClick={handleTracking}>
									Tra cứu
								</a>
							</Button>
						</Col>
					</Row>
				</div>
			</div>
			{isLoading ? (
				<div className="tracking-table">
					<Skeleton active />
				</div>
			) : isDetail ? (
				<DetailTracking
					key={orderDetail?.order?.orderCode}
					orderDetail={orderDetail}
					orderPackage={orderPackage}
					setStatusCode={setStatusCode}
					user={user}
					isUserOwner={isFullInfo}
					orderHistory={orderHistory}
					setIsDetail={setIsDetail}
					setIsSplitOrder={setIsSplitOrder}
				/>
			) : (
				<ListTracking orderList={orders} setIsDetail={setIsDetail} />
			)}

			<VerifyCodeViewTrackingModal open={openVerifyModal} onClose={() => setOpenVerifyModal(false)} onSend={onHandleSendNumberPhone} />
			<RecaptchaModal
				open={openCaptcha}
				onSuccess={handleCaptchaSuccess}
				onCancel={() => setOpenCaptcha(false)}
			/>
		</div>
	)
}

// Tracking.Layout = NewsLayout

export default Tracking
